import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { Button } from './ui/Button';
import { signOut } from '../lib/auth';

const PendingApprovalScreen: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut();
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9FAFB] flex items-center justify-center p-4">
      <div className="max-w-md w-full space-y-8 text-center">
        <div className="bg-white p-8 rounded-xl shadow-sm border border-[#EAECF0]">
          <div className="w-12 h-12 bg-[#F4EBFF] rounded-full flex items-center justify-center mx-auto mb-6">
            <svg
              className="w-6 h-6 text-[#7F56D9]"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>

          <h2 className="text-2xl font-semibold text-[#101828] mb-3">
            Account Pending Approval
          </h2>
          
          <p className="text-[#667085] mb-8">
            Your account is currently under review. An administrator will approve your
            account shortly. You'll receive an email notification once your account
            is activated.
          </p>

          <Button
            variant="secondary"
            onClick={handleLogout}
            leftIcon={<LogOut className="w-4 h-4" />}
            className="text-red-600 hover:text-red-700 hover:bg-red-50"
          >
            Logout
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PendingApprovalScreen;